import { Component, OnDestroy, OnInit } from "@angular/core";
import { getApp } from "../app";
import { WorkHistory } from "../../../../shared/models/workHistory";
import { downloadFile } from "../api.service";
import { EncodingUtils } from "../../../../shared/utils/encoding.utils";
import { saveAs } from "file-saver-es";

@Component({
  selector: "app-business-config",
  templateUrl: "./business-config.component.html",
  styleUrls: ["./business-config.component.scss"],
})
export class BusinessConfigComponent implements OnInit, OnDestroy {
  public viewType: "warehouse-group" | "processes" = "warehouse-group";

  app = getApp(async (app) => {
    this.app = app;
  });

  constructor() {}

  async ngOnInit(): Promise<void> {
    await this.app.businessConfig.getHistory();
  }

  getProcessesColumns(): string[] {
    return this.app.list.businessConfig.processesColumns.map(
      (field) => field.split(".")[1]
    );
  }

  async downloadLog(item: WorkHistory) {
    const fileLink = [
      this.app.customers.expectCurrent,
      "workHistory",
      EncodingUtils.encodeBase64(item._id),
      "log.txt",
    ].join("/");
    const data = await downloadFile(fileLink);
    const blob = new Blob([data], { type: data.type });

    saveAs(blob, "log.txt");
  }

  ngOnDestroy(): void {}
}
